// extracted by css-extract-rspack-plugin
var _1 = "EwA7ynhamSkJ49zv";
var _2 = "EwA7ynhamSkJ49zv";
var _3 = "giz5HZzwAwZdsCKU";
var _4 = "GGEvpn4kRHAdPi4K";
var _5 = "nZRVfCo_wn4Lw8rL";
export { _1 as "avatar-underline", _2 as "avatarUnderline", _3 as "formguide", _4 as "placeholder", _5 as "popover" }
